export class OrderPaymentCardCreationDto {
  constructor(data) {
    this.payment_profile_id = data.payment_profile_id;
    this.group_admin_id = data.group_admin_id;
    this.card = data.card != null ? {
      type: data.card.type,
      billing_address: data.card.billing_address,
      billing_zip: data.card.billing_zip,
      token: data.card.token,
      name: data.card.name,
    } : null;
    this.is_save_card = data.is_save_card;
  }
}
